class @AutoRefreshManager

  @isListenerInstalled = false
  @windowLastHiddenTime = null
  @maxTimeOffScreenToRefreshMs = 300 * 1000
  @instances = []

  @setup: (container, path) ->

    @installListener() unless @isListenerInstalled

    @instances.push(new AutoRefreshManager(container, path))

  @installListener: =>

    document.addEventListener "visibilitychange", =>
      if document.visibilityState == "visible"
        @windowLastHiddenTime = null

        for instance in @instances
          instance.refresh()
      else
        @windowLastHiddenTime = new Date()

    @isListenerInstalled = true

  @windowWasVisibleRecently = =>

    return true unless @windowLastHiddenTime

    timeSinceVisibleMs = new Date() - @windowLastHiddenTime

    timeSinceVisibleMs < @maxTimeOffScreenToRefreshMs

  constructor: (container, path) ->

    @container = container
    @path      = path
    @lastTime  = null
    @timeout   = null

    @refresh()

  refresh: =>

    $container = $(@container)
    delayMs    = UI.findAndSelf("[data-refresh-delay-ms]", $container).data("refresh-delay-ms")
    delayMs    = 5000 unless delayMs && delayMs > 0
    path       = if _.isFunction(@path) then @path() else @path
    time       = new Date()
    waitMs     = if @lastTime && @lastTime < time then ( delayMs - ( time - @lastTime ) ) else 0

    clearTimeout(@timeout) if @timeout
    @timeout = null

    # If we're being called sooner than we should, don't refresh yet.
    if waitMs > 0
      @timeout = setTimeout(@refresh, waitMs)
    # If we've been visible recently, do the refresh.
    else if AutoRefreshManager.windowWasVisibleRecently()
      $container.load(path)
      @lastTime = time
      @timeout = setTimeout(@refresh, delayMs)
